import React from 'react';
import { Link } from 'react-router';
import { Meta } from 'common/components/meta';
import PaymentTabs from 'account/containers/payout/payments_tabs';
import AwardsTable from 'account/containers/payout/awards_table';
import RequestPayment from 'account/containers/payout/request_payment';
import Accounts from 'account/containers/payout/accounts';

/**
 * Creatives payout management view.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const PayOut = ({ children }) => {
  const paymentsTable = children;

  return (
    <div id="content" className="l-content payout">
      <Meta title="Payments" />
      <div className="row">
        <div className="columns large-10 small-16">
          <div className="callout primary">
            <p>Is anything missing or incorrect? Don&apos;t panic.</p>
            <p>Please <Link to="/help/contact/">contact our support team</Link>.</p>
          </div>
          <h3 className="section-header">Payments</h3>
          <PaymentTabs />
          { paymentsTable }
        </div>
        <div className="columns large-6 small-16">
          <RequestPayment />
        </div>
      </div>

      <div className="row">
        <div className="columns large-10 small-16">
          <h3 className="section-header">Pending Awards</h3>
          <AwardsTable />
        </div>
        <div className="columns large-6 small-16">
          <Accounts />
        </div>
      </div>

    </div>)
}

export default PayOut;



// WEBPACK FOOTER //
// ./account/components/payout/index.jsx